/**
* Primary Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Primary Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'primary-hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.primary-hero-banner.primary-hero-banner__full-screen' ).each( function( key, val ) {
        const content = $( this ).find( '.container' )[0];

        gsap.set( content, {filter: 'blur(0px)', opacity: '1'} );
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top top',
            end: 'bottom -100%',
            scrub: 0,
            // markers: true,
          },
        } );
        tl.to( content, {filter: 'blur(10px)', opacity: '0', ease: 'linear'}, 0 );
      } );

      // $( '.primary-hero-banner.primary-hero-banner__regular' ).each( function( key, val ) {
      //   const content = $( this ).find( '.container' )[0];

      //   gsap.set( content, {filter: 'blur(0px)', opacity: '1'} );
      //   const tl = gsap.timeline( {
      //     scrollTrigger: {
      //       trigger: this,
      //       start: 'top 25%',
      //       end: 'bottom 25%',
      //       scrub: 0,
      //       // markers: true,
      //     },
      //   } );
      //   tl.to( content, {filter: 'blur(10px)', opacity: '0', ease: 'linear'}, 0 );
      // } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'primary-hero-banner', COMPONENT );
} )( app );
